import Store from '../Store/createStore';

// Keys with this prefix survive logout (see clearLocalStorage) so user preferences persist across sessions.
const PREFERENCES_PREFIX = 'med_pref_';

const getPreferenceKey = (name) => {
    const { authenticatedUser } = Store.getState().AUTH;
    return `${PREFERENCES_PREFIX}${name}_${authenticatedUser?.id ?? ''}`;
};

export const getUserPreference = (name, defaultValue) => {
    try {
        return localStorage.getItem(getPreferenceKey(name)) ?? defaultValue;
    } catch (error) {
        return defaultValue;
    }
};

export const setUserPreference = (name, value) => {
    try {
        localStorage.setItem(getPreferenceKey(name), value);
    } catch (error) {
        console.log(error);
    }
};

// Replacement for localStorage.clear() on logout that keeps user preferences.
export const clearLocalStorage = () => {
    try {
        Object.keys(localStorage)
            .filter((key) => !key.startsWith(PREFERENCES_PREFIX))
            .forEach((key) => localStorage.removeItem(key));
    } catch (error) {
        console.log(error);
    }
};
